import { Component } from 'react';
import classNames from 'classnames';
import Icon from 'noc/components/icon';

let isTabToDeleted = true;
let currentTabId;
let currentDisplayName;
let currentEditedTab;
let isTabToEdited = true;


export class SaveViewPopUp extends Component {
    constructor(props) {
        super(props);
        this.showPopUp = this.showPopUp.bind(this);
    }

    componentDidMount() {
        this.refs.viewName.focus();
    }

    componentDidUpdate() {
        this.refs.viewName.focus();
    }

    showPopUp(columnFilters) {
        this.refs.viewName.value = null;
        this.props.toggle(columnFilters, 'saveNewView');
        this.props.clearErrors('saveNewTab');
    }

    // todo: validateInputText to be moved to common location
    validateInputText(e) {
        const reg = /^[A-Za-z-_'\d\s']+$/;
        if (!reg.test(e.key)) {
            e.preventDefault();
        } else if (e.charCode === 13) {
            const { saveNewTab } = this.props;
            saveNewTab(this.refs.viewName.value);
        }
    }

    toogleDeleteConfirmation(deleteStatus, Id) {
        isTabToDeleted = deleteStatus !== false;
        currentTabId = Id;
        this.setState({ isTabToDeleted, currentTabId });
    }


    showHideEditMode(editModeShowStatus, selectedTab) {
        const { errors } = this.props;
        const renameErrors = errors.find(x => x.eventName === 'renameTab');
        renameErrors.errorMessage = editModeShowStatus === false ? [] : renameErrors.errorMessage;
        this.refs[`txt${selectedTab.Id}`].value = renameErrors.errorMessage.length > 0 ? this.refs[`txt${selectedTab.Id}`].value : selectedTab.DisplayName;
       // Todo : Refactored
        this.refs[`txt${selectedTab.Id}`].style.display = editModeShowStatus ? 'inline-block' : 'none';
        isTabToEdited = editModeShowStatus !== false;
        if (currentEditedTab !== null && currentEditedTab !== undefined) {
            if (currentEditedTab.Id !== selectedTab.Id) {
                this.refs[`txt${currentEditedTab.Id}`].style.display = 'none';
                renameErrors.errorMessage = [];
            }
        }
        currentDisplayName = selectedTab.DisplayName;
        currentEditedTab = selectedTab;
        this.setState({ currentDisplayName, isTabToEdited, currentEditedTab });
    }

    editTabDetails(selectedTab) {
        const { editTab, errors } = this.props;
        const Id = selectedTab.Id;
        const updatedDisplayName = this.refs[`txt${Id}`].value;
        const renameErrors = errors.find(x => x.eventName === 'renameTab');
        renameErrors.errorMessage = [];
        editTab(selectedTab.Id, updatedDisplayName);
        renameErrors.errorMessage.length > 0 ? this.showHideEditMode(true, selectedTab) : this.showHideEditMode(false, selectedTab);
    }

    render() {
        const { tabsData, saveNewView, manageView, columnFilters,
            toggle, saveNewTab, removeTab, requestForId, errors, clearFilters } = this.props;

        const saveNewErrors = errors.find(x => x.eventName === 'saveNewTab');
        const renameErrors = errors.find(x => x.eventName === 'renameTab');
        const tab = tabsData.find(x => x.Id === requestForId);
        const classes = classNames({
            'cn-dialog': true
        },
            {
                'cn-dialog--show': saveNewView
            });

        const fieldClass = classNames({
            'cn-field': true
        },
            {
                'cn-field--invalid': (saveNewErrors.errorMessage.length > 0)
            }
        );

        const fieldEditClass = classNames({
            'cn-field cn-field--overlay': true
        },
            {
                'cn-field--invalid': (renameErrors.errorMessage.length > 0)
            }
        );

        let style;
        if (!manageView) {
            style = 'none';
            isTabToDeleted = false;
            if (currentEditedTab !== null && currentEditedTab !== undefined) {
                if (this.refs[`txt${currentEditedTab.Id}`] !== undefined) {
                    this.refs[`txt${currentEditedTab.Id}`].style.display = 'none';
                    isTabToEdited = false;
                    renameErrors.errorMessage = [];
                }
            }
        } else {
            style = 'block';
        }
        return (
            <div className="cn-filterbar__controls">
                { tab.AdvanceSearch.length > 0 ? <a
                    href="#"
                    className="cn-filterbar__controls__link"
                    onClick={() => clearFilters()}
                >Clear Filters </a> : ''

                }
                { tabsData.length < 8 && tab.AdvanceSearch.length > 0 ? <span>&nbsp;| </span> : ''
                }
               {/* { tabsData.length < 8 ?
                    <a
                        href="#"
                        className="cn-filterbar__controls__link"
                        onClick={() => this.showPopUp(columnFilters)}
                    >Save As View</a> : ''
                } */}
                {/* { tabsData.length > 4 || tab.AdvanceSearch.length > 0 ? <span>&nbsp;| </span> : '' } */}
               {/* {tabsData.map(f => (
                    f.Id === requestForId && tabsData.length > 4 ?
                        <a
                            key={f.Id}
                            href="#"
                            className="cn-filterbar__controls__link"
                            onClick={() => toggle(columnFilters, 'manageView')}
                        >Manage Views</a>
                            : null))}*/}
                <div className={classes}>
                    <label className={fieldClass}>
                        <span className="cn-field__label">Name View</span>
                        <input
                            className="cn-field__input"
                            ref="viewName"
                            type="text"
                            maxLength="20"
                            onKeyPress={e => this.validateInputText(e)}
                        />
                        {(saveNewErrors.errorMessage.length > 0) ?
                            <small className="cn-field--error">{saveNewErrors.errorMessage[0]}.</small>
                            : ''
                        }
                    </label>
                    <div className="cn-dialog__footer">
                        <button
                            className="cn-btn cn-btn--small"
                            onClick={() => toggle(columnFilters, 'saveNewView')}
                        >Cancel</button>
                        <button className="cn-btn cn-btn--small cn-btn--primary" onClick={() => saveNewTab(this.refs.viewName.value)}>Save</button>
                    </div>
                </div>

                <div
                    style={{
                        display: style
                    }}
                    data-is-show="false"
                >
                    <div className="tmpl-overlay tmpl-overlay--smallest">
                        <div className="cn-banner">
                            <h3 className="cn-pgsubtitle">Manage Views</h3>
                            <a href="#" className="tmpl-overlay__close" onClick={() => toggle(columnFilters, 'manageView')} >
                                <Icon type="icon-close" icon="icon-close" />
                            </a>
                        </div>
                        <div className="cn-main">
                            {((renameErrors.errorMessage.length > 0) ?
                                <div className="cn-block cn-message cn-message--icon cn-message--dismissable cn-message--accented cn-message--error">
                                    <Icon type="cn-message__icon" icon="icon-remove" />
                                    <h3 className="cn-message__title cn-message__title">Error:</h3>
                                    <p className="cn-message__text"> {renameErrors.errorMessage[0]}.</p>
                                </div> : '')}
                            <div className="cn-manage-list">

                                {tabsData.map((f, index) => (
                                    <div className="cn-manage-list__item" key={index}>
                                        <div className="cn-manage-list__header">

                                            <h4 ref={`h${f.Id}`} className="cn-manage-list__title">
                                                {f.DisplayName}
                                            </h4>

                                            {((f.IsCustom) ?
                                                <label ref={`lbl${f.Id}`} className={fieldEditClass}>
                                                    <input ref={`txt${f.Id}`} className="cn-field__input cn-field--updated" type="text" style={{ display: 'none' }} onKeyPress={e => this.validateInputText(e)} maxLength="20" />
                                                </label> : '')}


                                            {(f.IsCustom ?
                                                <div className="cn-manage-list__actions" >
                                                    <a href="#" className="cn-toolbar__link" title="Edit" onClick={() => this.showHideEditMode(true, f)} >
                                                        <Icon type="cn-icon--tool" icon="icon-edit" />
                                                    </a>
                                                    <a
                                                        href="#" className="cn-toolbar__link"
                                                        onClick={() => this.toogleDeleteConfirmation(true, f.Id)} title="Delete"
                                                    >
                                                        <Icon type="cn-icon--tool" icon="icon-delete" />
                                                    </a>

                                                    { (currentTabId === f.Id && isTabToDeleted) ?
                                                        <div className="cn-btn cn-btn--overlay cn-btn--delete" aria-expanded="false">
                                                            <span className="cn-btn__text">Delete?</span>
                                                            <a href="#" onClick={() => removeTab(f.Id)} className="cn-link">
                                                                <Icon type="cn-btn__icon" icon="icon-resolve" />
                                                                <span className="a11y">Yes</span>
                                                            </a>
                                                            <a href="#" onClick={() => this.toogleDeleteConfirmation(false, f.Id)} className="cn-link">
                                                                <Icon type="cn-btn__icon" icon="icon-remove" />
                                                                <span className="a11y">No</span>
                                                            </a>
                                                        </div> : ''}


                                                    {
                                                        (currentDisplayName === f.DisplayName && isTabToEdited) ?
                                                        <div className="cn-btn cn-btn--overlay cn-btn--confirm" aria-expanded="false">
                                                            <span className="cn-btn__text">Save?</span>
                                                            <a href="#" className="cn-link">
                                                                <Icon type="cn-btn__icon" icon="icon-resolve" onClick={() => this.editTabDetails(f)} />
                                                                <span className="a11y">Yes</span>
                                                            </a>
                                                            <a href="#" className="cn-link" onClick={() => this.showHideEditMode(false, f)}>
                                                                <Icon type="cn-btn__icon" icon="icon-remove" />
                                                                <span className="a11y">No</span>
                                                            </a>
                                                        </div> : '' }

                                                </div>
                                                :
                                                <div className="cn-manage-list__actions">
                                                    <span className="cn-manage-list__text">PRESET</span>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SaveViewPopUp;



// WEBPACK FOOTER //
// ./app/components/save-new-view-popup.jsx